/**
 * @generated SignedSource<<1acf5f87c8e493e5494bbe0d809dd4cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendMessageInput = {
  attachments?: ReadonlyArray<AttachmentInput> | null | undefined;
  context?: string | null | undefined;
  contextData?: string | null | undefined;
  jobRunId?: any | null | undefined;
  llmConversationId?: any | null | undefined;
  message: string;
};
export type AttachmentInput = {
  handle: string;
};
export type EmptyChatsCreateConversationMutation$variables = {
  input: SendMessageInput;
};
export type EmptyChatsCreateConversationMutation$data = {
  readonly sendMessage: {
    readonly llmConversation: {
      readonly id: any;
    };
  };
};
export type EmptyChatsCreateConversationMutation = {
  response: EmptyChatsCreateConversationMutation$data;
  variables: EmptyChatsCreateConversationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendMessagePayload",
    "kind": "LinkedField",
    "name": "sendMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLLlmConversation",
        "kind": "LinkedField",
        "name": "llmConversation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmptyChatsCreateConversationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmptyChatsCreateConversationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "764938f58008fe0c9d6442fb64f8bdf9",
    "id": null,
    "metadata": {},
    "name": "EmptyChatsCreateConversationMutation",
    "operationKind": "mutation",
    "text": "mutation EmptyChatsCreateConversationMutation(\n  $input: SendMessageInput!\n) {\n  sendMessage(input: $input) {\n    llmConversation {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6dac091ab194f316e1ee6c5678c434a7";

export default node;
